import MarketingShell from '../../components/marketing-shell/MarketingShell'
import MarketingIcon from '../../components/marketing-icon/MarketingIcon'
import MarketingCtaStrip from '../../components/marketing-cta-strip/MarketingCtaStrip'
import { MARKETING_USE_CASES } from '../../_data/marketingContent'
import {
  CaseBody,
  CaseCard,
  CaseHead,
  CaseTitle,
  CasesInner,
  CasesSection,
  ExampleItem,
  ExamplesLabel,
  ExamplesList,
  Hero,
  HeroEyebrow,
  HeroHeadline,
  HeroInner,
  HeroSubhead,
} from './styled'

const UseCasesPage = (): JSX.Element => (
  <MarketingShell>
    <Hero>
      <HeroInner>
        <HeroEyebrow>Use cases</HeroEyebrow>
        <HeroHeadline>Built for anyone who books on a calendar.</HeroHeadline>
        <HeroSubhead>
          QuickCal didn&apos;t start as a niche tool with features bolted on
          for everyone else. The booking engine underneath doesn&apos;t care
          whether you&apos;re selling, hiring, supporting, or showing a
          two-bedroom in Liberty Village.
        </HeroSubhead>
      </HeroInner>
    </Hero>

    <CasesSection>
      <CasesInner>
        {MARKETING_USE_CASES.map((useCase) => (
          <CaseCard key={useCase.key}>
            <CaseHead>
              <MarketingIcon kind={useCase.iconKind} size="large" />
              <CaseTitle>{useCase.title}</CaseTitle>
            </CaseHead>
            <CaseBody>{useCase.body}</CaseBody>
            <ExamplesLabel>What teams actually book</ExamplesLabel>
            <ExamplesList>
              {useCase.examples.map((example) => (
                <ExampleItem key={example}>{example}</ExampleItem>
              ))}
            </ExamplesList>
          </CaseCard>
        ))}
      </CasesInner>
    </CasesSection>

    <MarketingCtaStrip
      eyebrow="Pick the use case that fits"
      headline="One booking engine. Yours to shape."
      body="QuickCal adapts to whichever workflow you've been duct-taping together. The setup is the same — the booked meetings end up wherever you need them."
      secondaryLabel="Browse features"
      secondaryHref="/features"
    />
  </MarketingShell>
)

export default UseCasesPage
